import { parseIso, getMonth } from '@landing/common/utils'


const isThisMonthBirthday = function (birthday) {
  const thisMonth = getMonth(new Date())
  return isMonthBirthday(birthday, thisMonth)
}

const isNextMonthBirthday = function (birthday) {
  const thisMonth = getMonth(new Date())
  const nextMonth = thisMonth + 1
  return isMonthBirthday(birthday, nextMonth)
}

const isMonthBirthday = function (birthday, month) {
  const birthdayMonth = getMonth(parseIso(birthday))
  return birthdayMonth == month
}

export {
  isThisMonthBirthday,
  isNextMonthBirthday
}